import React from 'react';
import { useNavigate } from 'react-router-dom';
import { tempoTravellerRoutes } from '../../../data/tempoTravellerRoutes';
import Icon from '../../../components/AppIcon';


const TempoTravellerRoutes = () => {
  const navigate = useNavigate();

  const getAllTempoRoutes = () => {
    const routes = [];
    const routeKeys = Object.keys(tempoTravellerRoutes);
    
    routeKeys?.forEach(key => {
      const route = tempoTravellerRoutes?.[key];
      if (route?.from && route?.to && route?.fareStart) {
        routes?.push({
          id: key,
          from: route?.from,
          to: route?.to,
          price: `₹ ${route?.fareStart}/-`,
          slug: key,
          image: route?.vehicles?.[0]?.image || "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
          alt: route?.vehicles?.[0]?.imageAlt || `Tempo Traveller from ${route?.from} to ${route?.to}`
        });
      }
    });
    
    return routes?.slice(0, 12);
  };

  const tempoRoutes = getAllTempoRoutes();

  const handleBookTempo = (route) => {
    navigate(`/tempo-traveller-booking/${route?.slug}`);
    window.scrollTo(0, 0);
  };

  const handleRouteClick = (route) => {
    navigate(`/tempo-traveller-route-booking/${route?.slug}`);
    window.scrollTo(0, 0);
  };

  return (
    <section className="py-16 bg-gradient-to-br from-orange-50 via-white to-purple-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 animate-fade-in-down">
          <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-600 via-purple-600 to-orange-600 mb-4">
            Tempo Traveller Routes
          </h2>
          <p className="text-gray-600 text-lg">
            Comfortable group travel with spacious Tempo Traveller vehicles
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {tempoRoutes?.slice(0, 8)?.map((route, index) => (
            <div
              key={index}
              onClick={() => handleRouteClick(route)}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer hover-lift border-2 border-transparent hover:border-orange-400 animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative h-48 overflow-hidden image-zoom">
                <img
                  src={route?.image}
                  alt={route?.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-white font-bold text-lg mb-1 transition-transform duration-300 group-hover:translate-x-2">
                    {route?.from} to {route?.to}
                  </h3>
                  <p className="text-orange-200 text-sm transition-transform duration-300 group-hover:translate-x-2">
                    Starting at ₹{route?.fareStart?.toLocaleString('en-IN')}
                  </p>
                </div>
              </div>
              <div className="p-4">
                <button className="w-full py-2.5 bg-gradient-to-r from-orange-500 to-purple-500 hover:from-orange-600 hover:to-purple-600 text-white font-bold rounded-lg transition-all duration-300 btn-hover transform hover:scale-105">
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 animate-fade-in">
          <button
            onClick={() => {
              navigate('/tempo-traveller');
              window.scrollTo(0, 0);
            }}
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-orange-600 to-purple-600 hover:from-orange-700 hover:to-purple-700 text-white font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 btn-hover"
          >
            <span>View All Routes</span>
            <Icon name="ArrowRight" size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TempoTravellerRoutes;